
import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

// Default visual token values — can be overridden via transient props on every usage.
const DEFAULTS = {
  bg:           "#fff1e6",
  border:       "1px solid rgba(232, 108, 55, 0.25)",
  borderRadius: "8px",
  padding:      "12px 16px",
  gap:          "12px",
  color:        "rgba(65, 74, 93, 1)",   // --color-base-grey-800
  fontSize:     "13px",
  fontWeight:   "400",
  lineHeight:   "1.45",
};

export const BannerRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  gap:           ${(p) => p.$gap          || DEFAULTS.gap};
  padding:       ${(p) => p.$padding      || DEFAULTS.padding};
  border:        ${(p) => p.$border       || DEFAULTS.border};
  border-radius: ${(p) => p.$borderRadius || DEFAULTS.borderRadius};
  background:    ${(p) => p.$bg           || DEFAULTS.bg};
  color:         ${(p) => p.$color        || DEFAULTS.color};
  font-family:   ${fontFamilies.regular};
  font-size:     ${(p) => p.$fontSize     || DEFAULTS.fontSize};
  font-weight:   ${(p) => p.$fontWeight   || DEFAULTS.fontWeight};
  line-height:   ${(p) => p.$lineHeight   || DEFAULTS.lineHeight};
`;

export const BannerIconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BannerIcon = styled.img`
  width:  ${(p) => p.$size || "20px"};
  height: ${(p) => p.$size || "20px"};
`;

export const BannerText = styled.span`
  /* inherits color, font-size, line-height from BannerRoot */
  color: inherit;
`;
